import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Kithimani";

const KithimaniSprings = () => {
  const projectId = 18;
  const title = "Kithimani Springs";

  const mapConfig = {
    minZoom: 15,
    zoom: 17,
    bounds: [
      [61.62166, 18.63],
      [61.617, 18.64],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/kithimani-springs-by-optiven/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSdVtTykoMyNYiao79RkUB3LuPYNDOCp_-KLXkPDds9dvP-JQg/viewform"
    />
  );
};

export default KithimaniSprings;
